import * as Sentry from '@sentry/react'

/**
 * Drift events fire only on actual Flux↔Zustand divergence, so an empty
 * drift dashboard is ambiguous: healthy mirrors and a broken delivery
 * pipeline look identical. This heartbeat is the disambiguator — a tiny
 * sampled liveness event on bridge mount, sharing the drift events' exact
 * delivery path (same SDK client, same beforeSend, same dashboard). Present
 * heartbeats + absent drift = healthy; flatlined heartbeats = delivery is
 * broken and drift would be invisible.
 *
 * 0.004 local sample × 0.25 Sentry client sampleRate (PublishSentryClient
 * applies it to every captured event) ≈ 0.1% of bridge mounts reported.
 * Keep in sync with the client rate.
 */
const HEARTBEAT_SAMPLE_RATE = 0.004

export function maybeEmitBridgeHeartbeat(): void {
  if (process.env.NODE_ENV !== 'production') return
  if (Math.random() > HEARTBEAT_SAMPLE_RATE) return

  Sentry.captureEvent({
    message: 'composer.bridge.heartbeat',
    level: 'info',
    fingerprint: ['composer-bridge-heartbeat'],
    tags: {
      track: 'heartbeat',
    },
  })
}
